import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import constants from '@/constants';
import { useLess } from '@/models/hooks';
import { px2vw } from '@/utils/phoneConfig';
// Introduction Return to Top Image

export default {
  __name: 'backTop',
  props: {
    // Target parameters
    scrollRef: {
      type: Object
    },
    // Right distance
    right: {
      type: Number,
      default: 16
    },
    // Bottom distance
    bottom: {
      type: Number,
      default: 172
    },
    // Slide the fixed distance to display the component
    offsetTop: {
      type: Number,
      default: 200
    }
  },
  setup(__props) {
    useLess('components/backTop.less');
    const {
      IMAGE_URL
    } = constants;
    // Introducing px2vw component for pixel conversion
    const backTop = `${IMAGE_URL}assets/svg/icon/backTop.svg`;
    // Obtain parameters from parent component

    return (_ctx, _cache) => {
      const _component_van_back_top = _resolveComponent("van-back-top");
      return _openBlock(), _createBlock(_component_van_back_top, {
        class: "vant-detail-back-top",
        target: __props.scrollRef,
        right: _unref(px2vw)(__props.right),
        bottom: _unref(px2vw)(__props.bottom),
        offset: __props.offsetTop
      }, {
        default: _withCtx(() => [_ctx.$slots.content ? _renderSlot(_ctx.$slots, "content", {
          key: 0
        }) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: backTop,
          alt: ""
        }))]),
        _: 3
      }, 8, ["target", "right", "bottom", "offset"]);
    };
  }
};